import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getToken } from '../../../../features/token/tokenSaver';
import { getScreenHosts } from '../../../../services/getScreenHosts';
import '../../AdminDashboardAdvertisers/AdminDashboardAdvertisers.css';

export default function ScreenHostsHome() {
    const navigate = useNavigate();
    const [hosts, setHosts] = useState([]);
    const token = useSelector(getToken);

    useEffect(() => {
        getScreenHosts(token)
            .then((response) => {
                setHosts(response.data.hosts || []);
            })
            .catch((e) => {
                console.error(e);
                setHosts([]);
            });
    }, [token]);

    return (
        <div>
            <span className="registeredScreensTitle advertiserListTitle">Screen Host Accounts</span>
            <input
                type="button"
                value="+"
                className="addAdvertiser"
                onClick={() => navigate('/adminDashboard/users/create')}
            />
            <div className="adminDashboardScreensTableContainer">
                {hosts.length > 0 && (
                    <table className="adminDashboardScreensTable">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Name</th>
                                <th>Business</th>
                                <th>Email</th>
                                <th>Active</th>
                                <th>Agreement</th>
                                <th>Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {hosts.map((host) => (
                                <tr
                                    key={host.UserId}
                                    onClick={() => navigate(`/adminDashboard/users/host/${host.UserId}`)}
                                >
                                    <td>{host.UserId}</td>
                                    <td>{`${host.FName || ''} ${host.LName || ''}`.trim()}</td>
                                    <td>{host.BusinessName || '—'}</td>
                                    <td>{host.Email}</td>
                                    <td>
                                        <span className={host.Active ? 'activeStatus' : 'inactiveStatus'}>
                                            {host.Active ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            className={
                                                host.AccountActivated ? 'activeStatus' : 'inactiveStatus'
                                            }
                                        >
                                            {host.AccountActivated
                                                ? host.HostAgreementLegalName || 'Signed'
                                                : 'Pending'}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="advertiserEditActionBtn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/adminDashboard/users/host/${host.UserId}`);
                                            }}
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {hosts.length === 0 && <div className="adminEmptyState">No admin-provisioned screen hosts yet.</div>}
            </div>
        </div>
    );
}
